<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <!-- scope.row[title.prop] -->
        <h1 class="block-title" style="margin-bottom: 20px">Events</h1>
        <el-table :data="table.records" v-loading="tableLoading">
          <el-table-column type="expand">
            <template slot-scope="props">
              <EventData :value="props.row.event_data"></EventData>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="Date" key="date"
            ><template slot-scope="scope"
              ><div :title="scope.row.date">
                {{ parsedDate(scope.row.date) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="Title" key="title">
            <template slot-scope="scope">
              <b>{{ scope.row.title }}</b>
            </template>
          </el-table-column>
          <el-table-column prop="atom_title" label="Atom" key="atom_title">
            <template slot-scope="scope">
              <router-link
                :to="{
                  name: 'SingleAtom',
                  params: { hash: scope.row.atom_hash },
                }"
              >
                {{ scope.row.atom_title }}</router-link
              >
            </template>
          </el-table-column>
          <el-table-column prop="task_title" label="Task" key="task_title">
            <template slot-scope="scope">
              <router-link
                :to="{ name: 'TaskView', params: { id: scope.row.task_id } }"
              >
                {{ scope.row.task_title }}</router-link
              >
            </template>
          </el-table-column>
          <el-table-column width="50">
            <template slot-scope="scope">
              <button type="button" class="btn btn-sm btn-icon del">
                <i class="vik vik-delete"></i>
              </button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px"
          background
          layout="prev, pager, next, sizes"
          :total="table.total"
          :page-sizes="[10, 100, 1000, 10000]"
          :page-size="resultsPageSize"
          @current-change="changePage"
          @size-change="changePageSize"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import EventData from "@/components/internal/EventData.vue";
export default {
  name: "Events",
  components: {
    EventData,
  },
  data() {
    return {
      tableLoading: true,
      table: {
        total: 0,
        filters: [],
        records: [],
        columns: [],
      },
      resultsPageNum: 1,
      resultsPageSize: 10,
    };
  },
  mounted() {
    this.loadEvents();
    // this.loadRSSFeed();
  },
  methods: {
    changePage(pageNum) {
      this.resultsPageNum = pageNum;
      this.loadEvents();
    },
    changePageSize(size) {
      this.resultsPageSize = size;
      this.loadEvents();
    },
    parsedDate(d) {
      return moment(d, "YYYY-MM-DD HH:mm:ss ZZ z").fromNow();
    },
    loadEvents() {
      let that = this;
      fetch(
        `/api/events/?page=${this.resultsPageNum}&pageSize=${this.resultsPageSize}`
      )
        .then(function (response) {
          that.tableLoading = false;
          that.loading = false;
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            return;
          }

          response.json().then(function (data) {
            that.table.records = data.values;
            that.table.total = parseInt(data.total);
          });
        })
        .catch((err) => {
          console.log("Fetch Error :-S", err);
        });
    },
    loadRSSFeed() {
      fetch("http://h1.nobbd.de/reports_rss.xml").then((res) => {
        console.log(res);
        res.text().then((data) => {
          console.log(data);
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Events.vue